// import React, { useState } from 'react';
// import TimePicker from 'react-time-picker';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import './contact.css';

// const Contact = () => {
//   const [time, setTime] = useState('10:00');
//   const [date, setDate] = useState(new Date());
//   const [formData, setFormData] = useState({
//     email: '',
//     name: '',
//     mobile: '',
//     address: '',
//     address2: '',
//     city: '',
//     state: '',
//     pincode: '',
//     site: 'Mussoorie, Uttarakhand (Prime Location)',
//   });




//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const response = await fetch('YOUR_API_GATEWAY_URL', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         ...formData,
//         date: date.toISOString().split('T')[0], // Sending date in YYYY-MM-DD format
//       }),
//     });
//     const result = await response.json();
//     if (response.ok) {
//       alert(result.message);
//     } else {
//       alert('Error submitting the form. Please try again.');
//     }
//   };

//   const handleInputChange = (e) => {
//     setFormData({ ...formData, [e.target.id]: e.target.value });
//   };

//   return (
//     <div className="cmargincontainer contact">
//       <div className="catchy">
//         <div className="mainformline">
//           <h2>No charges for the visit! Just schedule a time and fill out the form below. Let us take care of the rest! Your dream home is just a visit away.</h2>
//         </div>
//         <form id="contact-form" onSubmit={handleSubmit}>
//           <div className="form-row">
//             <div className="form-group">
//               <label htmlFor="inputEmail4" className="cformlabel">Email</label>
//               <input type="email" className="cforminput" id="inputEmail4" placeholder="Email" />
//             </div>
//             <div className="form-group">
//               <label htmlFor="name" className="cformlabel">Name</label>
//               <input type="text" className="cforminput" id="name" placeholder="Name" />
//             </div>
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label htmlFor="number" className="cformlabel">Mobile</label>
//               <input type="number" className="cforminput" id="number" placeholder="Contact Number" />
//             </div>
//             <div className="form-group">
//               <label htmlFor="inputAddress" className="cformlabel">Address</label>
//               <input type="text" className="cforminput" id="inputAddress" placeholder="1234 Main St" />
//             </div>
//           </div>
//           <div className="form-group">
//             <label htmlFor="inputAddress2" className="cformlabel">Address 2</label>
//             <input type="text" className="cforminput" id="inputAddress2" placeholder="Apartment, studio, or floor" />
//           </div>
//           <div className="form-row">
//             <div className="form-group">
//               <label htmlFor="inputCity" className="cformlabel">City</label>
//               <input type="text" className="cforminput" id="inputCity" placeholder="Ghaziabad" />
//             </div>
//             <div className="form-group">
//               <label htmlFor="inputState" className="cformlabel">State</label>
//               <input type="text" className="cforminput" id="inputState" placeholder="Uttar Pradesh" />
//             </div>
//             <div className="form-group">
//               <label htmlFor="inputZip" className="cformlabel">Pin Code</label>
//               <input type="text" className="cforminput" id="inputZip" />
//             </div>
//           </div>
//           <div className="form-group">
//             <label htmlFor="site" className="cformlabel">Site You Want To Visit</label>
//             <select className="cforminput" id="site">
//               <option selected>Mussoorie, Uttarakhand (Prime Location)</option>
//               <option>Dholera Gujarat (Investments)</option>
//               <option>Gadh Hapur (Best Sellers)</option>
//               <option>Delhi NCR (Plots, Flats, Rentals.....)</option>
//             </select>
//           </div>
//           <div className="form-group">
//             <label htmlFor="datepicker" className="cformlabel">Select Date:</label>
//             <DatePicker
//               selected={date}
//               onChange={(date) => setDate(date)}
//               className="cforminput"
//               placeholderText="Pick a date for site visit"
//             />
//           </div>
         
//           <button type="submit" className="btn">Submit</button>
//         </form>
//         <ul className="below-form">
//           <li><h3>Exclusive Pick-Up and Drop-Off Service!</h3><h4>Our team will ensure you get to and from the site comfortably and on time.</h4></li>
//           <li><h3>Convenient Scheduling!</h3><h4>Choose a time that works best for you, and we'll handle the rest.</h4></li>
//           <li><h3>Experience the Excitement Firsthand!</h3><h4>See your future home or investment up close with a personalized tour.</h4></li>
//           <li><h3>Your Perfect Home Awaits!</h3><h4>We take care of all the details, so you can focus on finding your dream property.</h4></li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Contact;4



import React from 'react'

const Contact = () => {
  return (
<>
<div className='bg-white'>
<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdQS44bKweo28C3LdftlMlAJbDBMOG0RHyoFxKtFJ-Doi6aaA/viewform?embedded=true"
 width="100%" height="2002" frameborder="0" marginheight="0" marginwidth="0">
  Loading…
 </iframe>
 </div> 
 
 </>
  )
}

export default Contact
